/**
 * Section type → human label for canvas badges and panel titles — single
 * source of truth (NOS-260). Covers every registered block type (enforced by
 * sectionLabels.test.ts) so badges never fall back to raw type names.
 */
export const SECTION_LABELS: Record<string, string> = {
  hero: "Hero",
  impact_stats: "Impact Stats",
  donation_cta: "Donation CTA",
  testimonials: "Testimonials",
  volunteer_signup: "Volunteer Signup",
  gallery: "Gallery",
  contact: "Contact",
  footer: "Footer",
  paragraph: "Paragraph",
  heading: "Heading",
  image: "Image",
  team_members: "Team Members",
  timeline: "Timeline",
  form: "Form",
  accordion: "Accordion",
  cards: "Cards",
  logo_grid: "Logo Grid",
  table: "Table",
  fundraising_goal: "Fundraising Goal",
  list: "List",
  blockquote: "Blockquote",
  video: "Video",
  callout: "Callout",
  image_text: "Image + Text",
  pull_quote: "Pull Quote",
  divider: "Divider",
  button: "Button",
  file_download: "File Download",
  embed: "Embed",
  newsletter_signup: "Newsletter Signup",
  author_bio: "Author Bio",
  map: "Map",
  donation_form: "Donation Form",
  campaign_banner: "Campaign Banner",
  latest_posts: "Latest Posts",
}

/**
 * Badge/panel label for a section: custom name (`content._name`) → per-context
 * override (e.g. blog relabels "heading" → "Content") → shared label →
 * prettified type name.
 */
export function getSectionLabel(
  sectionType: string,
  customName?: string,
  overrides?: Record<string, string>
): string {
  return (
    customName ||
    overrides?.[sectionType] ||
    SECTION_LABELS[sectionType] ||
    sectionType.replace(/_/g, " ")
  )
}
